export enum SHIPPING_PROVIDERS {
    ALTERNATIVE = 'Alternative',
    ALTERNATIVE_DENMARK = 'AlternativeDenmark',
    ALTERNATIVE_NETHERLANDS = 'AlternativeNetherlands',
    BRING_DENMARK = 'BringDenmark',
    BUSSGODS = 'Bussgods',
    COMBINED_SHIPPING = 'CombinedShipping',
    DHL = 'DHL',
    DHL_NETHERLANDS = 'DhlNetherlands',
    FEDEX = 'FedEx',
    NOT_SPECIFIED = 'NotSpecified',
    POSTNORD = 'Posten',
    POSTNORD_PARCEL = 'PostNordParcel',
    POSTNORD_STAMP = 'PostNordStamp',
    POSTNORD_STAMP_DENMARK = 'PostNordStampDenmark',
    SCHENKER = 'SchenkerPrivpak',
    TAKE_AWAY = 'Takeaway',
    TAKE_AWAY_ONLY = 'TakeawayOnly',
    UPS = 'Ups'
}
